type AppErrorData = Record<string, $TSFixMe>;

export default class AppError extends Error {
    name = 'AppError';

    code: string | undefined;

    data: AppErrorData | undefined;

    constructor(message: string, { code, data }: { code?: string; data?: AppErrorData } = {}) {
        super(message);
        this.code = code;
        this.data = data;
    }
}
